module.exports = __webpack_public_path__ + "static/img/33.3b130db.png";


//////////////////
// WEBPACK FOOTER
// ./static/goumai/33.png
// module id = i+/v
// module chunks = 14